import { MEDAL_TYPE } from '@/constant'
export const DEFAULT_HEADIMG = 'https://cdn.vip-wifi.com/fangchan/img/consultant-card/default_headimg.png'

export const METAL_MAP = {
    '': 'rank',
    [MEDAL_TYPE.ROOKIE]: 'super-rookie',
    [MEDAL_TYPE.GREAT]: 'great',
    [MEDAL_TYPE.PHONE]: 'phone-call',
    [MEDAL_TYPE.MSG]: 'msg-reply',
    [MEDAL_TYPE.EXPERT]: 'perfession',
    [MEDAL_TYPE.LEARNED]: 'learned'
}